"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselBlurBox: ()=>CarouselBlurBox
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const index_cjs_namespaceObject = require("../Divider/index.cjs");
const getComponentType = (child)=>{
    if (!child.props) return null;
    const id = child.props['data-id'];
    if ('carousel-numbers-text' === id) return 'numbers';
    if ('carousel-lightbox-button' === id) return 'lightbox';
    if ('carousel-autoplay-button' === id) return 'autoplay';
    return null;
};
const CarouselBlurBox = ({ children, slotClassNames = {} })=>{
    if (!children) return null;
    const validChildren = external_react_namespaceObject.Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(child));
    if (0 === validChildren.length) return null;
    const { blurBoxClasses = '', blurBoxDividerClasses = '' } = slotClassNames;
    const numbersComponents = validChildren.filter((child)=>'numbers' === getComponentType(child));
    const lightboxComponents = validChildren.filter((child)=>'lightbox' === getComponentType(child));
    const autoplayComponents = validChildren.filter((child)=>'autoplay' === getComponentType(child));
    const renderContent = ()=>{
        const elements = [];
        if (numbersComponents.length > 0) elements.push(...numbersComponents);
        if (lightboxComponents.length > 0) elements.push(...lightboxComponents);
        if (autoplayComponents.length > 0 && elements.length > 0) elements.push(/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Divider, {
            direction: "vertical",
            type: "solid",
            weight: 1,
            className: blurBoxDividerClasses,
            "data-testid": "carousel-blur-box-divider"
        }, "carousel-blur-box-divider"));
        if (autoplayComponents.length > 0) elements.push(...autoplayComponents);
        return elements;
    };
    const content = renderContent();
    if (0 === content.length) return null;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        "data-testid": "carousel-blur-box",
        className: blurBoxClasses,
        children: content
    });
};
exports.CarouselBlurBox = __webpack_exports__.CarouselBlurBox;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselBlurBox"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
